<template>
  <div class="home-div">
    <SideBar />

    <div class="search-container font-color-1">
      <div class="search-one">
        <div>
          <div class="title-1">Welcome To Here.</div>
          <div class="title-2">I’m Song Jian.This space holds my recordings of life’s beauty and the ordinary fragments
            I gather along the way.</div>
          <div class="title-3">「时序日志——了栀·风带来故事的种子」</div>
        </div>
        <div>
          <span style="position: relative;" v-for="item in linksList" :key="item.id" class="title-4"
            @click="handleToItem(item.links)">{{ item.title }} / </span>
          <div>
            <span v-for="(item, index) in menuList" :key="item.path" style="position: relative;" class="title-5"
              @click="$router.push(item.path)">
              {{ item.title }}
              <span v-if="index !== menuList.length - 1"> / </span>
            </span>
          </div>
        </div>
      </div>
      <div class="search-two">
        <div v-for="(item, index) in testimonialList" :key="item.id" class="testimonial-card" :class="{
          active: index === currentIndex,
          prev: index === getPrevIndex,
          next: index === getNextIndex,
          hidden: !(index === currentIndex || index === getPrevIndex || index === getNextIndex)
        }">
          <div class="card-div">
            <img :src="baseFileUrl + item.img" :alt="item.name">
          </div>
        </div>
      </div>
    </div>

    <div class="photography-art-section">
      <div class="text-block only-text">
        <p class="text-p">晨雾漫过山峦，晚风拂过林梢，星辰划过夜空，将那些散落在自然的时间，一一定格。这些影像，都将成为珍贵的记忆！</p>
      </div>
      <template v-for="(item, index) in testimonialList">
        <div class="art-card card-left-img fade-item" v-if="index % 2 === 0" :key="item.id" ref="fadeItems">
          <div class="art-img-box">
            <img :src="baseFileUrl + item.img" :alt="item.name" @click="openImgPreview(item.img)">
          </div>
          <div class="art-text-box">
            <h3 class="art-title">{{ item.name }}</h3>
            <p class="art-desc">{{ item.content }}</p>
          </div>
        </div>
        <div class="art-card card-right-img fade-item" v-else :key="item.id" ref="fadeItems">
          <div class="art-text-box">
            <h3 class="art-title">{{ item.name }}</h3>
            <p class="art-desc">{{ item.content }}</p>
          </div>
          <div class="art-img-box">
            <img :src="baseFileUrl + item.img" :alt="item.name" @click="openImgPreview(item.img)">
          </div>
        </div>
      </template>
      <div class="text-block only-text">
        <p class="text-p">行于山野，归于本心。那些定格的瞬间，是留给自然的一封信。于光影中，见天地，见众生，见自己。</p>
      </div>
    </div>


    <BottomTip />

    <div v-if="previewVisible" class="img-preview-mask" @click="closeImgPreview">
      <img :src="previewImgUrl" class="preview-img" alt="预览图片" />
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import TimesView from '@/components/tip/TimesView.vue';
import { Message } from 'element-ui';

import { getLinksList } from '@/api/links';
import { getCuratedAlbumLit } from '@/api/album';
import router from '@/router';
import config from '@/utils/Config';
export default {
  name: 'Transfer',
  components: {
    SideBar,
    BottomTip,
    TimesView
  },
  data() {
    return {
      baseFileUrl: config.BASE_FILE_URL,
      currentIndex: 1,
      testimonialList: [],
      linksList: [],
      isMobile: false,
      previewVisible: false,
      previewImgUrl: '',
      autoPlayTimer: null,
      scrollTimer: null, // 新增：节流定时器
      defaultAvatar: '',
      menuList: [
        { title: '云笺', path: '/life' },
        { title: '时光', path: '/nature' },
        { title: '流萤', path: '/danmaku' },
        { title: '友链', path: '/analysis' },
        { title: '游戏', path: '/mine' },
        { title: '足迹', path: '/travels' }
      ]
    };
  },
  async mounted() {
    await Promise.all([this.getCuratedAlbumLitInfo(), this.getLinksInfo()]);
    this.autoPlay();
    document.addEventListener('keydown', this.escClosePreview);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.$nextTick(() => {
      this.checkFadeItems();
    });
  },
  beforeDestroy() {
    if (this.autoPlayTimer) clearInterval(this.autoPlayTimer);
    document.removeEventListener('keydown', this.escClosePreview);
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimer) clearTimeout(this.scrollTimer); // 销毁节流定时器
  },
  computed: {
    getPrevIndex() {
      return (this.currentIndex - 1 + this.testimonialList.length) % this.testimonialList.length;
    },
    getNextIndex() {
      return (this.currentIndex + 1) % this.testimonialList.length;
    }
  },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth <= 768; },
    goPrev() { this.currentIndex = this.getPrevIndex; },
    goNext() { this.currentIndex = this.getNextIndex; },
    autoPlay() { this.autoPlayTimer = setInterval(() => this.goNext(), 5000); },
    async getLinksInfo() {
      try {
        const resp = await getLinksList({});
        if (resp.data && resp.code === 200) this.linksList = resp.data;
      } catch (error) { Message.error('获取外链错误！'); this.linksList = []; }
    },
    async getCuratedAlbumLitInfo() {
      try {
        const resp = await getCuratedAlbumLit({});
        if (resp.data && resp.code === 200) this.testimonialList = resp.data;
      } catch (error) { Message.error('获取精选集错误！'); this.testimonialList = []; }
    },
    handleToItem(event) {
      if (event === "/analysis") { router.push("/analysis"); return; }
      window.open(event, '_blank');
    },
    handleAvatarError(event) { event.target.src = this.defaultAvatar; },
    openImgPreview(imgUrl) {
      this.previewImgUrl = this.baseFileUrl + imgUrl;
      this.previewVisible = true;
      // ✅ 修复1：图片预览时 不隐藏滚动条，改用给body加样式，避免宽度抖动
      // document.body.classList.add('body-fixed');
    },
    closeImgPreview() {
      this.previewVisible = false;
      this.previewImgUrl = '';
      // ✅ 修复1：关闭预览时 移除样式即可
      document.body.classList.remove('body-fixed');
    },
    escClosePreview(e) {
      if (e.keyCode === 27 && this.previewVisible) {
        this.closeImgPreview();
      }
    },
    // ✅ 修复2：滚动监听 增加【节流函数】，减少DOM计算频率，解决性能抖动
    handleScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.checkFadeItems();
      }, 6); // 30ms执行一次，丝滑不卡顿，不影响动画触发
    },
    // ✅ 优化：保留原有逻辑，增加防抖+性能优化
    checkFadeItems() {
      const fadeItems = this.$refs.fadeItems;
      if (!fadeItems) return;
      const items = Array.isArray(fadeItems) ? fadeItems : [fadeItems];
      items.forEach(item => {
        if (!item || item.classList.contains('show')) return; // 已经显示的元素不再计算
        const rect = item.getBoundingClientRect();
        const isInView = rect.top < window.innerHeight - 200 && rect.bottom > 0;
        if (isInView) {
          item.classList.add('show');
        }
      });
    }
  }
};
</script>

<style scoped>
.search-two {
  width: 50%;
  height: calc(100vh - 165px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  order: 2;
  padding: 20px;
  perspective: 1500px;
  overflow: hidden;
  gap: 30px;
  margin-top: 40px;
}

.testimonial-card {
  height: 70%;
  position: absolute;
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  backface-visibility: hidden;
}

.testimonial-card.active {
  width: 50%;
  z-index: 3;
  transform: translateX(0) scale(1);
  opacity: 1;
}

.testimonial-card.prev {
  width: 40%;
  z-index: 2;
  transform: translateX(-80%) scale(0.85);
  opacity: 0.7;
}

.testimonial-card.next {
  width: 40%;
  z-index: 2;
  transform: translateX(80%) scale(0.85);
  opacity: 0.7;
}

.testimonial-card.hidden {
  display: none;
}

.card-div img {
  width: 100%;
  height: auto;
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
}

.carousel-btn {
  position: absolute;
  bottom: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #7c4dff;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  transition: background-color 0.3s;
}

.carousel-btn:hover {
  background-color: #6a3ed9;
}

.btn-prev {
  left: 50%;
  transform: translateX(-60px);
}

.btn-next {
  left: 50%;
  transform: translateX(20px);
}

@media only screen and (max-width: 768px) {
  .search-two {
    width: 100%;
    min-height: 60vh;
    order: 3;
    perspective: 1000px;
    margin-top: 0 !important;
    padding: 0 10px;
  }

  .testimonial-card.active {
    width: 80%;
  }

  .testimonial-card.prev,
  .testimonial-card.next {
    width: 70%;
    transform: translateX(-60%) scale(0.8);
  }

  .carousel-btn {
    bottom: 10px;
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }

  .btn-prev {
    left: 30%;
    transform: translateX(0);
  }

  .btn-next {
    left: 70%;
    transform: translateX(0);
  }

  .search-container {
    flex-direction: column;
    padding-top: 30px;
  }

  .search-one {
    width: 90% !important;
    flex-direction: column !important;
    align-items: center;
    justify-content: center;
  }

  .title-1 {
    font-size: 30px;
    text-align: center;
  }

  .title-2,
  .title-3 {
    text-align: center;
  }

  .title-3 {
    font-size: 18px;
    padding-left: 0 !important;
  }

  .title-3::before {
    display: none;
  }

  .search-one>div:nth-child(2) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .title-4,
  .title-5 {
    font-size: 14px;
  }
}

.search-one {
  width: 40%;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  order: 1;
  margin-top: 20px;
}

[class^="title-"] {
  margin-bottom: 24px;
  line-height: 1.6;
  opacity: 0;
  transform: translateX(-20px);
  animation: fadeIn 0.8s ease forwards;
}

.title-1 {
  animation-delay: 0.2s;
}

.title-2 {
  animation-delay: 0.5s;
}

.title-3 {
  animation-delay: 0.8s;
}

.title-4 {
  animation-delay: 1.1s;
}

.title-5 {
  animation-delay: 1.4s;
}

.title-1 {
  font-family: "Playfair Display", serif;
  font-size: 40px;
  font-weight: 600;
  color: var(--font-color-5);
  letter-spacing: 2px;
  border-bottom: 2px solid #fff;
}

.title-2 {
  font-size: 14px;
  color: var(--font-color-6);
  font-style: italic;
  line-height: 1.8;
  text-align: justify;
  text-indent: 2em;
}

.title-3 {
  font-size: 20px;
  font-weight: 500;
  color: var(--font-color-6);
  position: relative;
  padding-left: 16px;
}

.title-3::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 12px;
  height: 1px;
  background-color: var(--font-color-6);
  transition: width 0.3s ease;
}

.title-3:hover::before {
  width: 20px;
}

.title-4,
.title-5 {
  font-size: 16px;
  color: var(--font-color-5);
  letter-spacing: 1px;
  cursor: pointer;
  position: relative;
}

.title-4::after,
.title-5::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--font-color-6);
  transition: width 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}

.title-4:hover,
.title-5:hover {
  color: var(--font-color-6);
  font-weight: bold;
  transform: translateY(-2px);
}

.title-4:hover::after,
.title-5:hover::after {
  width: 100%;
}

.home-div {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.search-container {
  z-index: 2;
  padding-top: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  transition: all 0.5s ease;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(255, 71, 87, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

.barrage-wrapper.scrolling:hover {
  animation-play-state: paused;
}

.barrage-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  animation: fadeIn 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.photography-art-section {
  width: 85%;
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  gap: 80px;
}

.text-block.only-text {
  width: 70%;
  margin: 0 auto;
  padding: 10px;
}

.text-block .text-p {
  font-size: 17px;
  font-style: italic;
  text-align: center;
  color: #2c3e50;
  line-height: 1.2;
  background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
  background-size: 400% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 8s ease-in-out infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.art-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 40px;
}

.card-left-img {
  flex-direction: row;
}

.card-right-img {
  flex-direction: row;
  justify-content: space-between;
}

.art-img-box {
  width: 35%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
  transition: all 0.6s ease;
}

.art-img-box img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  object-position: center;
  transition: all 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  cursor: zoom-in;
}

.art-img-box:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
}

.art-text-box {
  width: 55%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.art-title {
  font-size: 24px;
  color: var(--font-color-5);
  font-weight: 500;
  letter-spacing: 2px;
  margin: 0;
  position: relative;
  padding-bottom: 8px;
}

.art-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 1px;
  background-color: #d9c8b8;
}

.art-desc {
  font-style: italic;
  color: var(--font-color-6);
  text-shadow: var(--text-shadow-fuji);
  font-size: 16px;
  line-height: 2.2;
  letter-spacing: 1px;
  text-align: justify;
  margin: 0;
  text-indent: 2em;
}

.card-top-img {
  flex-direction: column;
  gap: 30px;
}

.card-top-img .art-img-box.full-width {
  width: 100%;
  height: auto;
}

.card-top-img .bottom-text {
  width: 80%;
  margin: 0 auto;
  text-align: center;
}

.card-top-img .art-title::after {
  left: 50%;
  transform: translateX(-50%);
}

@media only screen and (max-width:768px) {
  .photography-art-section {
    width: 95%;
    gap: 50px;
    margin: 30px auto;
  }

  .text-block.only-text {
    width: 100%;
    padding: 0 !important;
  }

  .text-block .text-p {
    font-size: 14px;
    line-height: 2;
  }

  .art-card {
    flex-direction: column !important;
    gap: 25px;
  }

  .art-img-box {
    width: 100%;
    height: auto;
  }

  .art-text-box {
    width: 100%;
    padding: 0 10px;
  }

  .art-title {
    font-size: 20px;
  }

  .art-desc {
    font-size: 14px;
    line-height: 2;
  }

  .card-top-img .art-img-box.full-width {
    height: auto;
  }
}

.img-preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.preview-img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 10px;
  cursor: zoom-out;
  animation: imgShow 0.3s ease forwards;
}

@keyframes imgShow {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-item {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.9s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}

.fade-item.show {
  opacity: 1;
  transform: translateY(0);
}
</style>
<!-- ✅ 新增独立样式，不修改原有样式，解决图片预览滚动条抖动 -->
<style>
.body-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  padding-right: 17px;
  box-sizing: border-box;
}
</style>